/**
 * Represents the download type of file
 */
const DownloadTypeEnum = {
  FlowResult: 1,
  DocumentCheckResult: 2,
  ExternalFlowZip: 3,
  ExternalFlowZipForSign: 4,
  ExternalFlowZipWithSign: 5,
};

export default DownloadTypeEnum;
